<template>
	
	<Modal :value="value" title="选择年份" @on-cancel = "cancel">
		<Form ref="deleteForm"  :label-width="80" :rules="rule" :model="salary">
			<FormItem label='年份'  prop="year">
				<DatePicker
				  type="year"
				  @on-change="salary.year=$event"
				  v-model="salary.year"
				  placeholder="请选择"
				  :editable="false"
				  style="width:180px; padding-right:20px;"
				></DatePicker>
			</FormItem>
		</Form>
		<div slot="footer">
			<!-- <Button type="primary" @click="test" :loading='BtnDisabled'>检测</Button>&nbsp; -->
			<Button type="primary" @click="imports" >下载</Button>&nbsp;
		</div>
	</Modal>
	
</template>

<script>
import Util from '../../../lib/util';
import moment from "moment";
	export default {
		props:{
			value:false,
		},
		data () {
			return {
				BtnDisabledOK:true,
				BtnDisabled:false,
				action:abp.url+'/file/Upload',
				salary:{
					year:null
				},
				rule:{
					year: [
					  {
					    required: true,
					    pattern: /.+/,
					    message: '年份不能为空',
					    trigger: 'blur',
					  },
					],
				},
			}
		},
		mounted() {
			
		},
		methods:{
			
			//假期分配
			imports(){
				this.downloadFile(`/Leavefile/DownloadModel_PostWorkdaySettings?year=${this.salary.year}`, '导入岗位工作日模板');
			},
			cancel(){
				this.$emit('close')
			},
			downloadFile(url, title) {
			    const date = moment(new Date()).format('yyyyMMDDHHmm');
			    let _this = this;
			    let consturl = this.$constDefinition.baseUrl + url; //下载地址url
			    var xhr = new XMLHttpRequest();
			    xhr.open('get', consturl, true); // get、post都可
			    xhr.responseType = 'blob';
			    xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`); //加请求头
			    xhr.onload = function () {
			        console.log(xhr);
			        if (xhr.status == 200) {
			            let blob = new Blob([this.response], {
			                type: 'application/vnd.ms-excel',
			            });
			            var a = document.createElement('a');
			            var url = window.URL.createObjectURL(blob);
			            a.href = url;
			            a.download = title + date + '.xls'; // 文件名
			            if (xhr.readyState === 4) {
			                _this.$Message.success({
			                    content: '下载成功',
			                    duration:3
			                });
			            }
			        } else {
			            _this.$Message.error({
			                content: '下载失败',
			                duration:3
			            });
			        }
			        a.click();
			        window.URL.revokeObjectURL(url);
			    };
			    xhr.send();
			},
		}
	}
</script>

<style>
</style>
